// extracted by mini-css-extract-plugin
export default {"container":"NvHomeVolunteers_container__TJQvG","volunteers":"NvHomeVolunteers_volunteers__belo7","testimonoalSection":"NvHomeVolunteers_testimonoalSection__RSigU"};